import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'digi-date-picker',
  templateUrl: './input-date-picker.component.html',
  styleUrl: './input-date-picker.component.scss'
})
export class InputDatePickerComponent implements OnInit {
  @Input() control!: FormControl;
  @Input() label: string = '';
  @Input() placeholder: string = 'dd/mm/yyyy';
  @Input() minDate: Date | null = null;
  @Input() maxDate: Date | null = null;
  ngOnInit() {
    // Đăng ký theo dõi thay đổi của control
    this.control.valueChanges.subscribe(() => {
      // Khi có thay đổi, component sẽ tự động cập nhật view
    });
  }

  get hasValue(): boolean {
    return this.control && this.control.value !== null && this.control.value !== '';
  }

    formatDate(event: KeyboardEvent) {
    if (event.key === 'Backspace')
      return;

    var targetE = event.target as HTMLInputElement;
    var numerics = targetE.value.replace(/[^0-9]/g, '');
    if (numerics.length > 8) {
      targetE.value = numerics.substring(0, 8);
      return;
    }

    let result = numerics.match(/.{1,4}/g);
    let dateString: any = [];

    result?.forEach((p, i) => {
      if (i === 0) {
        let arr = p.match(/.{1,2}/g);
        arr?.forEach(p => dateString.push(p));
      } else {
        dateString.push(p);
      }
    });

    let date = new Date();
    date.setDate(Number.parseInt(dateString[0]));
    date.setMonth(Number.parseInt(dateString[1]) - 1);
    date.setFullYear(Number.parseInt(dateString[2]));
    date.setHours(0);
    date.setMinutes(0);
    date.setMilliseconds(0);
    if (!isNaN(date.getTime())) {
      if(this.minDate != null && this.minDate > date){
        targetE.value = ''
        return
      }
      if(this.maxDate != null && this.maxDate < date){
        targetE.value = ''
        return
      }
      this.control.setValue(date);
    } else {
      targetE.value = dateString.join('/');
    }
  }
}
